import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilePlus2, FolderOpen } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { DUPLICATE_CATEGORIES } from '../../pages/ContractDetail';
import { ExistingContractPicker } from './ExistingContractPicker';

const LABEL = { energias: 'Luz e Gás', telecomunicacoes: 'Telecomunicações' };
const card = 'flex items-center gap-2 p-3 rounded-xl border border-slate-200 hover:border-[#2D3E6F] text-sm text-left transition-colors';

export const UseInContractDialog = ({ file, onClose }) => {
  const navigate = useNavigate();
  const [mode, setMode] = useState(null);
  const [cat, setCat] = useState(null);
  const close = () => { setMode(null); setCat(null); onClose(); };
  const back = () => (cat ? setCat(null) : setMode(null));
  const go = (comp) => navigate(`/contracts/${cat.key}/${comp.key}/new?chat_file=${encodeURIComponent(file.id)}`);
  const hint = !mode ? 'Novo contrato ou contrato que já existe?' : mode === 'existente' ? 'Indique o NIF e marque o(s) contrato(s)' : cat ? `Escolha a empresa (${LABEL[cat.key] || cat.label})` : 'Escolha o tipo de serviço';
  return (
    <Dialog open={!!file} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md" data-testid="chat-use-contract-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="break-all">Usar “{file?.name}”</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">{hint}</p>
        {!mode && (
          <div className="grid grid-cols-2 gap-2">
            <button type="button" onClick={() => setMode('novo')} className={card} data-testid="chat-use-mode-novo"><FilePlus2 className="w-5 h-5 text-[#2D3E6F]" />Contrato novo</button>
            <button type="button" onClick={() => setMode('existente')} className={card} data-testid="chat-use-mode-existente"><FolderOpen className="w-5 h-5 text-[#2D3E6F]" />Contrato existente</button>
          </div>
        )}
        {mode === 'existente' && <ExistingContractPicker file={file} onDone={close} />}
        {mode === 'novo' && (
          <div className="grid grid-cols-2 gap-2">
            {!cat && DUPLICATE_CATEGORIES.map((c) => {
              const Icon = c.icon;
              return (
                <button key={c.key} type="button" onClick={() => setCat(c)} data-testid={`chat-use-cat-${c.key}`} className={card}>
                  <span className={`w-8 h-8 rounded-lg ${c.bgColor} flex items-center justify-center`}><Icon className={`w-4 h-4 ${c.iconColor}`} /></span>{LABEL[c.key] || c.label}
                </button>
              );
            })}
            {cat && cat.companies.map((comp) => (
              <button key={comp.key} type="button" onClick={() => go(comp)} data-testid={`chat-use-comp-${comp.key}`}
                className="p-3 rounded-xl border border-slate-200 hover:border-[#2D3E6F] text-sm font-medium transition-colors">{comp.name}</button>
            ))}
          </div>
        )}
        {mode && <button type="button" onClick={back} className="text-xs text-slate-500 underline self-start" data-testid="chat-use-back">Voltar</button>}
      </DialogContent>
    </Dialog>
  );
};
